// Drift: anmeldelser fra kunderne på Supabase (del af SupabaseApi – se supabase.ts; 20261029800000_anmeldelser.sql).
// Siden er offentlig (tokenet fra mailen er adgangen); kontoret læser og svarer med evnerne kundecenter.se/kundecenter.behandl.
import type { Api } from './api';
import type { SbKontekst } from './sbKatalog';
import { gyldigtAnmeldToken, tjekAnmeld } from '../../core/anmeldelse';

export class SbAnmeld {
  constructor(private readonly c: SbKontekst) {}

  anmeldSide: Api['anmeldSide'] = async (token) => {
    if (!gyldigtAnmeldToken(token)) return null;
    return (await this.c.k(this.c.sb.rpc('anmeldelse_hent', { p_token: token }))) as Awaited<ReturnType<Api['anmeldSide']>>;
  };
  anmeld: Api['anmeld'] = async (token, i) => {
    const p = tjekAnmeld(i);
    return (await this.c.k(this.c.sb.rpc('anmeldelse_gem', { p_token: token, p }))) as Awaited<ReturnType<Api['anmeld']>>;
  };
  kundeAnmeldelser: Api['kundeAnmeldelser'] = async () =>
    (await this.c.k(this.c.sb.rpc('anmeldelser_liste', { k: await this.c.kraevKlient() }))) as Awaited<ReturnType<Api['kundeAnmeldelser']>>;
  retAnmeldelse: Api['retAnmeldelse'] = async (id, p) => {
    await this.c.k(this.c.sb.rpc('ret_anmeldelse', { k: await this.c.kraevKlient(), p_id: id, p }));
    this.c.skift();
  };
}
